import { Link, useLocation, type LinkProps } from "react-router-dom";
import { isSettingsStackPath, markNavDirection } from "./navigationUtils";

export function StackNavLink({ to, onClick, state, viewTransition: _viewTransition, ...props }: LinkProps) {
  const location = useLocation();
  const target = typeof to === "string" ? to : `${to.pathname || ""}${to.search || ""}`;
  const useStackTransition = isSettingsStackPath(target);
  const mergedState = { from: location.pathname, ...(typeof state === "object" && state ? state : {}) };

  return (
    <Link
      {...props}
      to={to}
      state={mergedState}
      onClick={(event) => {
        if (useStackTransition) markNavDirection("forward");
        onClick?.(event);
      }}
    />
  );
}
